<template>
    <div class="ctbox">

        <el-form id='ctboxid' :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px"
                 class="demo-ruleForm login-container">
            <h3 class="title">系统登录</h3>
            <el-form-item prop="account">
                <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="请输入手机号"
                          @keyup.enter.native="onEnter"></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
                <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"
                          @keyup.enter.native="onEnter"></el-input>
            </el-form-item>
            <!--<el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
            <!--<el-form-item style="width:100%;margin-top: 50px;">-->
            <el-button type="primary" style="width:100%;" @click="handleSubmit2" :loading="logining">登录</el-button>
            <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
            <!--</el-form-item>-->
            <el-form-item class="title" style="margin-top: 20px;">
                <el-button type="text" @click="register">注册账号</el-button>
                <el-button type="text" @click="forget">忘记密码</el-button>
            </el-form-item>
            <el-form-item class="title" style="margin-top: 40px;">
                欢迎登陆上海邦邦机器人后台管理系统
            </el-form-item>
        </el-form>
        <el-dialog title="注册账号" :visible.sync="registerOutVisible" width="600px" center top="10%">
            <el-form :model="registerForm" :rules="rules3" ref="registerForm" label-position="left">

                <el-form-item label="真实姓名" label-width="80px" prop="nickname">
                    <el-input v-model="registerForm.nickname" auto-complete="off" placeholder="请输入姓名，管理员将进行审核"
                              style="width: 480px;" :maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="手机号" label-width="80px" prop="username">
                    <el-input v-model="registerForm.username" auto-complete="off" placeholder="请输入手机号" :maxlength="11"
                              style="width: 480px;"></el-input>
                </el-form-item>
                <el-form-item label="验证码" label-width="80px" prop="vercode">
                    <el-input v-model="registerForm.vercode" auto-complete="off" placeholder="请输入验证码" :maxlength="6"
                              style="width: 350px;"></el-input>
                    <el-button type="text" @click="sendcode" :disabled='sendDisable'>{{btntext}}</el-button>
                </el-form-item>
                <el-form-item label="密码" label-width="80px" prop="pwd">
                    <el-input type="password" v-model="registerForm.pwd" auto-complete="off"
                              placeholder="请输入密码(密码长度在 8 到 30 个字符)" style="width: 480px;"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" label-width="80px" prop="pwdsure">
                    <el-input type="password" v-model="registerForm.pwdsure" auto-complete="off" placeholder="请再次输入密码"
                              style="width: 480px;"></el-input>
                </el-form-item>
                <el-form-item label="邀请码" label-width="80px" prop="authcode">
                    <el-input v-model="registerForm.authcode" auto-complete="off" placeholder="请输入邀请码"
                              style="width: 480px;"></el-input>
                </el-form-item>
            </el-form>

            <el-dialog width="30%" title="提示" :visible.sync="registerInnerVisible" append-to-body></el-dialog>
            <div slot="footer" class="dialog-footer">
                <!--<el-button @click="registerVisible = false">取 消</el-button>-->
                <el-button type="primary" @click="upmessage('registerForm')" style="width: 200px;">注 册</el-button>
            </div>
        </el-dialog>

        <el-dialog title="忘记密码" :visible.sync="forgetOutVisible" width="600px" center top="10%">
            <el-form :model="forgetForm" :rules="rules4" ref="forgetForm" label-position="left">
                <el-form-item label="手机号" label-width="80px" prop="username">
                    <el-input v-model="forgetForm.username" auto-complete="off" placeholder="请输入手机号" :maxlength="11"
                              style="width: 480px;"></el-input>
                </el-form-item>
                <el-form-item label="验证码" label-width="80px" prop="vercode">
                    <el-input v-model="forgetForm.vercode" auto-complete="off" placeholder="请输入验证码" :maxlength="6"
                              style="width: 350px;"></el-input>
                    <el-button type="text" @click="sendcode" :disabled='sendDisable'>{{btntext}}</el-button>
                </el-form-item>
                <el-form-item label="新密码" label-width="80px" prop="pwd">
                    <el-input type="password" v-model="forgetForm.pwd" auto-complete="off"
                              placeholder="请输入新密码(密码长度在 8 到 30 个字符)" style="width: 480px;"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" label-width="80px" prop="pwdsure">
                    <el-input type="password" v-model="forgetForm.pwdsure" auto-complete="off" placeholder="请再次输入密码"
                              style="width: 480px;"></el-input>
                </el-form-item>
            </el-form>

            <el-dialog width="30%" title="提示" :visible.sync="forgetInnerVisible" append-to-body></el-dialog>
            <div slot="footer" class="dialog-footer">
                <!--<el-button @click="registerVisible = false">取 消</el-button>-->
                <el-button type="primary" @click="forgetUp('forgetForm')" style="width: 200px;">确认修改</el-button>
            </div>
        </el-dialog>
    </div>


</template>

<script>
    import {reqLogin, GetDealerlist} from '../api/api';
    //import NProgress from 'nprogress'
    export default {
        data() {
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.registerForm.pwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            var validatePass3 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.forgetForm.pwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                firstUrl: 'https://baknd.bangbangrobotics.com/v1/identity/',
                logining: false,
                ruleForm2: {
                    account: '',
                    checkPass: ''
                },
                rules2: {
                    account: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        //{ validator: validaePass }
                    ],
                    checkPass: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        //{ validator: validaePass2 }
                    ]
                },
                rules3: {
                    username: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {
                            validator: function (rule, value, callback) {
                                if (/^1[34578]\d{9}$/.test(value) == false) {
                                    callback(new Error("请输入正确的手机号"));
                                } else {
                                    callback();
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    vercode: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                        {min: 6, max: 6, message: '请输入正确的6位验证码', trigger: 'blur'}
                    ],
                    pwd: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 8, max: 30, message: '密码长度在 8 到 30 个字符'}
                    ],
                    pwdsure: [
                        {required: true, message: '请再次输入密码', trigger: 'blur'},
                        {validator: validatePass2, trigger: 'blur'}
                    ],
                    nickname: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                        {min: 1, max: 30, message: '姓名不能大于 30 个字符'}
                    ],
                    authcode: [
                        {required: true, message: '请输入邀请码', trigger: 'blur'}
                    ],
                },
                rules4: {
                    username: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {
                            validator: function (rule, value, callback) {
                                if (/^1[34578]\d{9}$/.test(value) == false) {
                                    callback(new Error("请输入正确的手机号"));
                                } else {
                                    callback();
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    vercode: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                        {min: 6, max: 6, message: '请输入正确的6位验证码', trigger: 'blur'}
                    ],
                    pwd: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 8, max: 30, message: '密码长度在 8 到 30 个字符'}
                    ],
                    pwdsure: [
                        {required: true, message: '请再次输入密码', trigger: 'blur'},
                        {validator: validatePass3}
                    ],
                    authcode: [
                        {required: true, message: '请输入邀请码', trigger: 'blur'}
                    ],
                },
                checked: true,
                registerOutVisible: false,
                registerInnerVisible: false,
                forgetOutVisible: false,
                forgetInnerVisible: false,
                registerForm: {
                    username: '1',
                    vercode: '2',
                    pwd: '3',
                    pwdsure: '',
                    nickname: '',
                    authcode: ''
                },
                forgetForm: {
                    username: '1',
                    vercode: '2',
                    pwd: '3',
                    pwdsure: '',
                    authcode: ''
                },
                btntext: '发送验证码',
                sendDisable: false
            };
        },
        methods: {
            register() {
                this.registerOutVisible = true
            },
//  	注册提交
            upmessage(formName) {
                var that = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var param = {
                            "username": that.registerForm.username,
                            "nickname": that.registerForm.nickname,
                            "country_code": "86",
                            "password": that.registerForm.pwdsure,
                            "code": that.registerForm.vercode,
                            "r_code": that.registerForm.authcode
                        }
                        var ull = that.firstUrl + 'users'
                        that.axios.post(ull, param).then(res => {
                            console.log(res)
                            that.$message({
                                message: '恭喜你，注册成功。',
                                type: 'success'
                            });
                            for (var i in that.registerForm) {
                                that.registerForm[i] = ''
                            }
                            that.registerOutVisible = false
                        }).catch(err => {
                            that.$message.error(err.response.data.message);
                        })

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
//  	密码重置提交
            forgetUp(formName) {
                var that = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var param = {
                            "country_code": "86",
                            "password": that.forgetForm.pwd,
                            "retype_password": that.forgetForm.pwdsure,
                            "code": that.forgetForm.vercode
                        }
                        var ull = that.firstUrl + 'users/' + that.forgetForm.username + '/password'
                        that.axios.post(ull, param).then(res => {
                            console.log(res)
                            that.$message({
                                message: '恭喜你，密码重置成功。',
                                type: 'success'
                            });
                            for (var i in that.forgetForm) {
                                that.forgetForm[i] = ''
                            }
                            that.forgetOutVisible = false
                        }).catch(err => {
                            that.$message.error(err.response.data.message);
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
            forget() {
                this.forgetOutVisible = true
            },
            sendcode() {
                var that = this

                var ull
                if (that.registerOutVisible) {
                    ull = that.firstUrl + 'vcodes/' + that.registerForm.username + '?country_code=86'
                } else if (that.forgetOutVisible) {
                    ull = that.firstUrl + 'vcodes/' + that.forgetForm.username + '?country_code=86'
                }

                that.axios.get(ull).then(res => {
                    console.log(res)
                    that.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    that.sendDisable = true
                    this.btntext = '请60s后再试'
                    var a = 60
                    var timer = setInterval(function () {
                        if (a > 1) {
                            a--
                            that.btntext = '请' + a + 's后再试'
                        } else {
                            clearInterval(timer)
                            that.sendDisable = false
                            that.btntext = '发送验证码'
                        }
                    }, 1000)
                }).catch(err => {
                    console.log(err.response.data.status)
                    if (err.response.data.status == 429) {
                        that.$message.error('同一手机号一分钟内只允许发送一个验证代码');
                    } else {
                        that.$message.error('验证码发送失败');
                    }
                })

            },
            handleReset2() {
                this.$refs.ruleForm2.resetFields();
            },
//    show(ev){
//          if(ev.keyCode == 13){
//              this.handleSubmit2();
//          }
//      },
            handleSubmit2(ev) {
                var _this = this;
                this.logining = true;
                var loginParams = {"username": _this.ruleForm2.account, "password": _this.ruleForm2.checkPass};

                this.$refs.ruleForm2.validate((valid) => {
                    if (valid) {
                        //         	reqLogin(loginParams).then(res => {
                        //        		_this.$message({
//				          message: '请使用手机号注册新账号',
//				          type: 'warning'
//				        });
//				_this.logining = false;
//        		sessionStorage.setItem("user",res.username);
//				sessionStorage.setItem("BBRtoken",res.access_token);
//				sessionStorage.setItem("limits",JSON.stringify(res.role.permissions))
//				_this.$router.push({ path: '/main' });
                        //        	}).catch(err => {
//        		console.log(err)
                        var ull = _this.firstUrl + 'tokens'
                        _this.axios.post(ull, loginParams).then(res => {
                            _this.logining = false;
                            console.log(res)
                            sessionStorage.setItem("user", res.data.nickname);
                            sessionStorage.setItem("BBRtoken", res.data.access_token);
                            sessionStorage.setItem("limits", JSON.stringify(res.data.permissions));
                            _this.$router.push({path: '/main'});
                        }).catch(err => {
                            console.log('err', err.response.status)
                            if (err.response.status == 422) {
                                _this.$message.error('用户名或密码错误')
                            } else {
                                _this.$message.error('对不起，请求失败。')
                            }
                            _this.logining = false;
                        })
                        //         	})
                        //_this.$router.replace('/table');


//          reqLogin(loginParams).then(data => {
////          	console.log(data)
//            this.logining = false;
//            //NProgress.done();
////            console.log(data)
////            if(data.success){
//            	sessionStorage.setItem("user",data.username);
//								sessionStorage.setItem("BBRtoken",data.access_token);
//								sessionStorage.setItem("limits",JSON.stringify(data.role.permissions))
//            	this.$router.push({ path: '/main' });
////            }else{
////            	console.log("res",data)
////            	this.$message.error(data.info);
////            }
//          }).catch(err => {
//          	console.log(err)
//          	if(err.response.data.message){
//          		this.$message.error(err.response.data.message)
//          	}else{
//          		this.$message.error('对不起，请求错误。')
//          	}
//          	this.logining = false;
//          });
                    } else {
                        this.$message.error('输入有误!!')
                        this.logining = false;
                        return false;
                    }
                });
            },
            onEnter() {
                if (this.ruleForm2.account && this.ruleForm2.checkPass) {
                    this.handleSubmit2();
                }else if (!this.ruleForm2.account) {
                    this.$message.error('请输入手机号');
                }else if (!this.ruleForm2.checkPass){
                    this.$message.error('请输入登录密码');
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .ctbox {
        width: 100%;
        height: 100%;
        background: url(../../static/img/Starry.jpg) no-repeat;
        background-size: cover;
        position: relative;
    }

    #ctboxid .el-input {
        margin-bottom: 20px;
    }

    .login-container {
        /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/

        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        /*margin: 180px auto;*/
        width: 300px;
        height: 400px;
        padding: 35px 35px 15px 35px;
        background: rgba(0, 0, 0, .5);
        /*border: 1px solid #eaeaea;*/
        /*box-shadow: 0 0 25px #cac6c6;*/
        box-shadow: -15px 20px 40px rgba(6, 17, 47, .7);


        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;


        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #d3d7f7;
        }

        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// Login.vue?0151100a